//@flow

// Vendors
import React from 'react';
import { ButtonPrimary } from 'texkit/dist/components/Buttons';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';

// Components
import { Modal } from '../../modals';
import Trans from '../../Trans/Trans';

//Actions
import { closeModal } from '../../../../reducers/modal/modalActions';
import { clearLinkServiceData } from '../../../../reducers/agency/linkService/linkServiceActions';

// Styles
import './dps-dlr-lockout-modal.scss';

const DpsDlrLockoutModal = () => {
  const dispatch = useDispatch();

  const goToDashboard = () => {
    dispatch(clearLinkServiceData());
    dispatch(push('/dashboard'));
  };

  return (
    <Modal
      name="DpsDlrLockoutModal"
      className="dps-dlr-lockout-modal"
      onClose={() => dispatch(closeModal('DpsDlrLockoutModal'))}
      disableOnClickOutside
    >
      <h2 className="h1 modal-title">
        <Trans
          file="Modals"
          id="Linking_DLR_Lockout_Header"
          fallback="Driver license (DL) or ID services temporarily locked"
        />
      </h2>

      <div className="modal-content">
        <Trans
          file="Modals"
          id="Linking_DLR_Lockout_Body"
          fallback="There were too many unsuccessful attempts for this request. To protect your personal information, we locked your access to link a driver license or ID card for 24 hours."
        />
      </div>

      <img
        className="dlr-lockout-graphic"
        src="/public/Illustration_locked%20out.png"
        alt=""
        role="presentation"
      />

      <ButtonPrimary
        className="modal-close-button"
        onClick={() => {
          dispatch(closeModal('DpsDlrLockoutModal'));
          goToDashboard();
        }}
      >
        <Trans
          file="Labels"
          id="ReturnToDashboard"
          fallback="Back to TxT dashboard"
        />
      </ButtonPrimary>
    </Modal>
  );
};

export default DpsDlrLockoutModal;
